module.exports = __webpack_public_path__ + "static/media/excel.d910cedd.svg";